<template>
  <button
    :class="['icon-button size-8 p-1', buttonClasses]"
    type="button"
    @click="onClick"
    @click.prevent="onClickPrevent"
  >
    <VTooltip
      :placement="placement"
      :skidding="skidding"
      :distance="distance"
      :class="toolTipClasses"
    >
      <span
        :class="['material-symbols-outlined notranslate', iconClasses]"
        translate="no"
        aria-hidden="true"
      >
        <slot name="icon"></slot>
      </span>
      <template #popper><slot name="popper"></slot></template>
    </VTooltip>
  </button>
</template>

<script setup lang="ts">
interface Props {
  buttonClasses?: string
  toolTipClasses?: string
  iconClasses?: string
  placement?: string
  distance?: number
  skidding?: number
}

withDefaults(defineProps<Props>(), {
  buttonClasses: '',
  toolTipClasses: '',
  iconClasses: '',
  placement: 'bottom',
  distance: 10,
  skidding: 0
})

const emit = defineEmits<{
  (e: 'click'): void
  (e: 'click-prevent'): void
}>()

const onClick = () => {
  emit('click')
}

const onClickPrevent = () => {
  emit('click-prevent')
}
</script>
